// extracted by mini-css-extract-plugin
export default {"favBtn":"AdminMobileSaleStatusList_favBtn__mkTp2","favIcon":"AdminMobileSaleStatusList_favIcon__HvfMS","favorite":"AdminMobileSaleStatusList_favorite__DKbdm"};